import React, { useState, useEffect } from "react";
import OtpInput from "react-otp-input";
import Alert from '@material-ui/lab/Alert';
import FingerPrintAuth from './FingerPrintAuth';
import { DialogTitle, FormControl, TextField } from '@material-ui/core';
import {
    OTP_LENGTH,
    MFA_TYPE_OTP,
    MFA_TYPE_FINGERPRINT
} from '../constants/Common';
import {
    MFA_RESPONSE_DATA,
    TEMPORARY_USER_TOKEN
} from "../constants/ActionTypes";
import { useDispatch, useSelector } from 'react-redux';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from "@material-ui/core/CircularProgress";
import { isMFAValid } from '../actions/Auth';
import {
    Typography,
    Grid,
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    Zoom,
    useMediaQuery,
    useTheme
} from "@material-ui/core";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom direction="up" ref={ref} {...props} />;
});

const MFACheck = (props) => {

    const theme = useTheme();
    const dispatch = useDispatch();
    const { user, open, handleClose } = props;
    const [trials] = useState(0);
    const [otpValue, setOtpValue] = useState("");
    const [hasErrors, setHasErrors] = useState(false);
    const [mfaMessage, setMfamessage] = useState(null);
    const [isDeactivated, setIsDeactivated] = useState(false);
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const { loading } = useSelector(({ commonData }) => commonData);
    let { mfa } = useSelector((state) => state.auth);

    const handleChange = (key) => {
        setOtpValue(key);
        //console.log('otpValueotpValue',otpValue)
    };

    const handleChangeStyle = (key) => {
        setOtpValue(key);
        //console.log('otpValueotpValue',otpValue)
    };

    useEffect(() => {
        if (otpValue.length >= OTP_LENGTH) {
            dispatch(
                isMFAValid({
                    DATA: otpValue
                })
            );
        }
    }, [otpValue]);

    useEffect(() => {
        //Handled by the acton itself
        if (mfa && mfa.valid === false) {
            setHasErrors(!hasErrors);
            let _mfaErrMsg = (user.MFA_TYPE === MFA_TYPE_FINGERPRINT) ? `Invalid fingerprint` : `Invalid OTP ${trials} trials`;
            setMfamessage(_mfaErrMsg);
        }
        if (mfa && mfa.reLogin === true) {
            _relogin();
        }

        if (mfa && mfa.accInactivated === true) {
            setIsDeactivated(!isDeactivated)
            setMfamessage("Account has been DEACTIVATED,please contact the administrator");
        }
        if (mfa && mfa.message !== null) {
            setMfamessage(mfa.message);
        }
    }, []);

    const _relogin = () => {
        sessionStorage.clear();
        dispatch({ type: TEMPORARY_USER_TOKEN, payload: null });
        dispatch({ type: MFA_RESPONSE_DATA, payload: { valid: "" } });
        handleClose();
    }
    // console.log('User data', user)

    return (

        <Dialog
            open={open}
            TransitionComponent={Transition}
            //keepMounted
            onClose={(e) => {
                e.preventDefault();
                _relogin();
            }}
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
            aria-labelledby="alert-dialog-zoom-title"
            aria-describedby="alert-dialog-zoom-description"
            fullScreen={fullScreen}
            fullWidth={true}
            maxWidth={"xs"}
            style={{borderRadius:'10px'}}
        >
            <DialogContent style={{ padding: 5, margin: 0 }}>
                <DialogTitle style={{backgroundColor:'#19a02b', textAlign:'center',padding:'5px'}}>
               
               {
                    user.MFA_TYPE === MFA_TYPE_FINGERPRINT ? 
                    <Typography variant="h7" style={{color:'white'}}>FINGERPRINT AUTHENTICATION</Typography> :
                    <Typography variant="h7" style={{color:'white'}}>ONE TIME PASSWORD</Typography>
               }
                
                </DialogTitle>
                <DialogContentText id="alert-dialog-slide-description">
                    <Grid
                        container
                        spacing={1}
                    >
                        <Grid
                            item
                            sm={12}
                            xs={12}
                        >
                            <Grid item md={12}>
                                {(mfaMessage || hasErrors) &&
                                    <Alert style={{ width: '90%' }} severity="error">{mfaMessage}</Alert>
                                }
                            </Grid>

                            <Grid item md={12}>
                                <center>
                                    {
                                        loading &&
                                        <CircularProgress />
                                    }</center>
                            </Grid>
                            {
                                user.MFA_TYPE === MFA_TYPE_FINGERPRINT &&
                                <Grid item md={12} style={{ alignContent: 'center',padding:'10px' }}>
                                    {/* <Typography variant="h5" style={{ marginTop: '10px', marginBottom:'10px' }}>FINGERPRINT AUTHENTICATION</Typography> */}
                                    <div style={{}}>
                                    <FingerPrintAuth authFunc={isMFAValid} />
                                    </div>
                                    
                                    <br />  <br />
                                        <Button
                                            variant="contained"
                                            size="medium"
                                            fullWidth
                                            onClick={(e) => {
                                                e.preventDefault();
                                                _relogin();
                                            }} color="primary">
                                            BACK TO LOGIN
                                        </Button>
                                </Grid>
                            }
                            {
                                user.MFA_TYPE != MFA_TYPE_FINGERPRINT ?
                                    <Grid item md={12} style={{ alignContent: 'center', padding: '8px' }}>
                                        {/* <Typography variant="h5">ONE TIME PASSWORD</Typography> */}
                                        <Typography style={{ color: 'green', marginTop: '10px', marginBottom:'10px' }} variant="h10">A verification code has been sent to your email/sms</Typography>
                                        <br />
                                        <br />
                                        {/* <TextField
                                            name="otp"
                                            label="Enter OTP"
                                            autoComplete="otp"
                                            value={otpValue}
                                            variant="outlined"
                                            margin="dense"
                                            required
                                            onChange={(event) => { handleChange(event.target.value) }}
                                            fullWidth
                                        />
                                        <br />  <br /> */}
                                        <centre>
                                        <OtpInput
                                            value={otpValue}
                                            onChange={handleChangeStyle}
                                            numInputs={6}
                                            separator={<span></span>}
                                            inputStyle={{width:'80%'}}
                                            containerStyle={{marginLeft:'10%',marginRight:'10%'}}
                                        />
                                        </centre>
                                        <br/><br/>
                                        <Button
                                            variant="contained"
                                            size="medium"
                                            fullWidth
                                            onClick={(e) => {
                                                e.preventDefault();
                                                _relogin();
                                            }} color="primary">
                                            BACK TO LOGIN
                                        </Button>
                                    </Grid> : <></>
                            }
                        </Grid>

                    </Grid>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};

export default MFACheck;
